{
  "identities.messages.1010001": "سائن ان ڪريو",
  "identities.messages.1010002": "{provider} سان سائن ان ڪريو",
  "identities.messages.1010003": "مهرباني ڪري هن عمل جي تصديق ڪندي تصديق ڪريو ته اهو توهان آهيو.",
  "identities.messages.1010004": "مهرباني ڪري ٻي تصديقي چئلينج مڪمل ڪريو.",
  "identities.messages.1010005": "تصديق ڪريو",
  "identities.messages.1010006": "تصديقي ڪوڊ",
  "identities.messages.1010007": "بيڪ اپ بحالي ڪوڊ",
  "identities.messages.1010008": "هارڊويئر ڪيئي سان جاري رکو",
  "identities.messages.1010009": "جاري رکو",
  "identities.messages.1010010": "جاري رکو",
  "identities.messages.1010011": "هارڊويئر ڪيئي سان سائن ان ڪريو",
  "identities.messages.1010012": "پنهنجي WebAuthn ڊيوائس (مثال طور سيڪيورٽي ڪيئي، بايوميٽرڪس اسڪينر، ...) تيار ڪريو ۽ جاري رکڻ کي دٻايو.",
  "identities.messages.1010013": "جاري رکو",
  "identities.messages.1010014": "توهان جي ڏنل پتي تي هڪ ڪوڊ موڪليو ويو. جيڪڏهن توهان کي اهو نه مليو، مهرباني ڪري پتي جي اسپيلنگ چيڪ ڪريو ۽ ٻيهر ڪوشش ڪريو.",
  "identities.messages.1010015": "سائن ان ڪوڊ موڪليو",
  "identities.messages.1010016": "توهان \"{duplicateIdentifier}\" سان سائن ان ڪرڻ جي ڪوشش ڪئي، پر اها اي ميل اڳ ۾ ئي ٻئي اڪائونٽ طرفان استعمال ٿيل آهي. پنهنجي اڪائونٽ ۾ سائن ان ڪريو هيٺين اختيارن مان هڪ سان توهان جي اڪائونٽ \"{duplicateIdentifier}\" کي \"{provider}\" تي سائن ان ڪرڻ جي ٻئي طريقي طور شامل ڪرڻ لاءِ.",
  "identities.messages.1010017": "سائن ان ۽ لنڪ ڪريو",
  "identities.messages.1010018": "{provider} سان تصديق ڪريو",
  "identities.messages.1010019": "جاري رکڻ لاءِ ڪوڊ جي درخواست ڪريو",
  "identities.messages.1010021": "پاس ڪيئي سان سائن ان ڪريو",
  "identities.messages.1010022": "پاس ورڊ سان سائن ان ڪريو",
  "identities.messages.1010023": "{address} تي ڪوڊ موڪليو",
  "identities.messages.1040001": "سائن اپ ڪريو",
  "identities.messages.1040002": "{provider} سان سائن اپ ڪريو",
  "identities.messages.1040003": "جاري رکو",
  "identities.messages.1040004": "سيڪيورٽي ڪيئي سان سائن اپ ڪريو",
  "identities.messages.1040005": "توهان جي ڏنل پتي(پتن) تي هڪ ڪوڊ موڪليو ويو آهي. جيڪڏهن توهان کي پيغام نه مليو، پتي جي اسپيلنگ چيڪ ڪريو ۽ رجسٽريشن ٻيهر ڪوشش ڪريو.",
  "identities.messages.1040006": "سائن اپ ڪوڊ موڪليو",
  "identities.messages.1040007": "پاس ڪيئي سان سائن اپ ڪريو",
  "identities.messages.1040008": "واپس",
  "identities.messages.1040009": "مهرباني ڪري پاڻ کي تصديق ڪرڻ لاءِ هڪ سندنامي چونڊيو.",
  "identities.messages.1050001": "توهان جون تبديليون محفوظ ٿي ويون آهن!",
  "identities.messages.1050002": "{provider} لنڪ ڪريو",
  "identities.messages.1050003": "{provider} ان لنڪ ڪريو",
  "identities.messages.1050004": "TOTP Authenticator ايپ ان لنڪ ڪريو",
  "identities.messages.1050005": "Authenticator ايپ QR ڪوڊ",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "بيڪ اپ بحالي ڪوڊ ظاهر ڪريو",
  "identities.messages.1050008": "فعال ڪريو",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "هي توهان جا بيڪ اپ بحالي ڪوڊ آهن. مهرباني ڪري انهن کي محفوظ جاءِ تي رکو!",
  "identities.messages.1050011": "بيڪ اپ بحالي ڪوڊ جي تصديق ڪريو",
  "identities.messages.1050012": "سيڪيورٽي ڪيئي شامل ڪريو",
  "identities.messages.1050013": "سيڪيورٽي ڪيئي جو نالو",
  "identities.messages.1050014": "ڳجهو {used_at, date, long} تي استعمال ٿيو",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "هن طريقي کي غير فعال ڪريو",
  "identities.messages.1050017": "Authenticator ڳجهو",
  "identities.messages.1050018": "سيڪيورٽي ڪيئي \"{display_name}\" هٽايو",
  "identities.messages.1050019": "پاس ڪيئي شامل ڪريو",
  "identities.messages.1050020": "پاس ڪيئي \"{display_name}\" هٽايو",
  "identities.messages.1060001": "توهان پنهنجي اڪائونٽ کي ڪاميابي سان بحال ڪيو. مهرباني ڪري پنهنجو پاس ورڊ تبديل ڪريو يا ايندڙ {privileged_session_expires_at_unix_until_minutes} منٽن اندر متبادل لاگ ان طريقو سيٽ ڪريو (مثال طور سوشل سائن ان).",
  "identities.messages.1060002": "توهان جي ڏنل اي ميل پتي تي بحالي لنڪ تي مشتمل هڪ اي ميل موڪليو ويو آهي. جيڪڏهن توهان کي اي ميل نه مليو، پتي جي اسپيلنگ چيڪ ڪريو ۽ پڪ ڪريو ته توهان جيڪو پتو رجسٽر ڪيو استعمال ڪريو.",
  "identities.messages.1060003": "توهان جي ڏنل اي ميل پتي تي بحالي ڪوڊ تي مشتمل هڪ اي ميل موڪليو ويو آهي. جيڪڏهن توهان کي اي ميل نه مليو، پتي جي اسپيلنگ چيڪ ڪريو ۽ پڪ ڪريو ته توهان جيڪو پتو رجسٽر ڪيو استعمال ڪريو.",
  "identities.messages.1060004": "هڪ بحالي ڪوڊ \"{masked_address}\" تي موڪليو ويو آهي. جيڪڏهن توهان کي اهو نه مليو، پتي جي اسپيلنگ چيڪ ڪريو ۽ پڪ ڪريو ته توهان جيڪو پتو رجسٽر ڪيو استعمال ڪريو.",
  "identities.messages.1060005": "پنهنجو بحالي پتو مڪمل طور تي مهيا ڪندي پنهنجي اڪائونٽ تائين رسائي بحال ڪريو.",
  "identities.messages.1060006": "توهان پنهنجي اڪائونٽ کي ڪيئن بحال ڪرڻ چاهيو ٿا؟",
  "identities.messages.1060007": "واپس",
  "identities.messages.1070001": "پاس ورڊ",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "محفوظ ڪريو",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "جمع ڪرايو",
  "identities.messages.1070006": "ڪوڊ جي تصديق ڪريو",
  "identities.messages.1070007": "اي ميل",
  "identities.messages.1070008": "ڪوڊ ٻيهر موڪليو",
  "identities.messages.1070009": "جاري رکو",
  "identities.messages.1070010": "بحالي ڪوڊ",
  "identities.messages.1070011": "تصديقي ڪوڊ",
  "identities.messages.1070012": "رجسٽريشن ڪوڊ",
  "identities.messages.1070013": "لاگ ان ڪوڊ",
  "identities.messages.1070014": "لاگ ان ۽ سندنامي لنڪ ڪريو",
  "identities.messages.1070015": "مهرباني ڪري جاري رکڻ لاءِ ڪيپچا چئلينج مڪمل ڪريو.",
  "identities.messages.1070016": "بحالي پتو",
  "identities.messages.1070017": "فون نمبر",
  "identities.messages.1080001": "توهان جي ڏنل اي ميل پتي تي تصديقي لنڪ تي مشتمل هڪ اي ميل موڪليو ويو آهي. جيڪڏهن توهان کي اي ميل نه مليو، پتي جي اسپيلنگ چيڪ ڪريو ۽ پڪ ڪريو ته توهان جيڪو پتو رجسٽر ڪيو استعمال ڪريو.",
  "identities.messages.1080002": "توهان پنهنجي اي ميل پتي جي ڪاميابي سان تصديق ڪئي.",
  "identities.messages.1080003": "توهان جي ڏنل اي ميل پتي تي تصديقي ڪوڊ تي مشتمل هڪ اي ميل موڪليو ويو آهي. جيڪڏهن توهان کي اي ميل نه مليو، پتي جي اسپيلنگ چيڪ ڪريو ۽ پڪ ڪريو ته توهان جيڪو پتو رجسٽر ڪيو استعمال ڪريو.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "مهرباني ڪري {property} داخل ڪريو ۽ ٻيهر ڪوشش ڪريو.",
  "identities.messages.4000003": "ڊيگهه >= {min_length} هجڻ گهرجي، پر {actual_length} مليو",
  "identities.messages.4000004": "نمونو \"{pattern}\" سان ملندو نٿو",
  "identities.messages.4000005": "پاس ورڊ استعمال نه ٿو ڪري سگهجي ڇاڪاڻ ته {reason}.",
  "identities.messages.4000006": "ڏنل سندنامي غلط آهن، پنهنجي پاس ورڊ يا يوزرنيم، اي ميل پتي، يا فون نمبر ۾ اسپيلنگ جي غلطين جي چيڪ ڪريو.",
  "identities.messages.4000007": "ساڳي سڃاڻپ ڪندڙ (اي ميل، فون، يوزرنيم، ...) سان اڪائونٽ اڳ ۾ ئي موجود آهي.",
  "identities.messages.4000008": "ڏنل تصديقي ڪوڊ غلط آهي، مهرباني ڪري ٻيهر ڪوشش ڪريو.",
  "identities.messages.4000009": "ڪو به لاگ ان سڃاڻپ ڪندڙ نه مليا. ڇا توهان انهن کي سيٽ ڪرڻ وساري ويا؟ اهو شايد سرور جي غلط تشڪيل جي ڪري پڻ ٿي سگهي ٿو.",
  "identities.messages.4000010": "اڪائونٽ اڃا فعال نٿو. ڇا توهان پنهنجي اي ميل پتي جي تصديق ڪرڻ وساري ويا؟",
  "identities.messages.4000011": "توهان وٽ ڪو TOTP ڊيوائس سيٽ اپ نه آهي.",
  "identities.messages.4000012": "هي بيڪ اپ بحالي ڪوڊ اڳ ۾ ئي استعمال ٿي چڪو آهي.",
  "identities.messages.4000013": "توهان وٽ ڪو WebAuthn ڊيوائس سيٽ اپ نه آهي.",
  "identities.messages.4000014": "توهان وٽ ڪو بيڪ اپ بحالي ڪوڊ سيٽ اپ نه آهي.",
  "identities.messages.4000015": "هي اڪائونٽ موجود نٿو يا ڪا به سيڪيورٽي ڪيئي سيٽ اپ نٿي ڪئي.",
  "identities.messages.4000016": "بيڪ اپ بحالي ڪوڊ صحيح نٿو.",
  "identities.messages.4000017": "ڊيگهه <= {max_length} هجڻ گهرجي، پر {actual_length} مليو",
  "identities.messages.4000018": ">= {minimum} هجڻ گهرجي پر {actual} مليو",
  "identities.messages.4000019": "> {minimum} هجڻ گهرجي پر {actual} مليو",
  "identities.messages.4000020": "<= {maximum} هجڻ گهرجي پر {actual} مليو",
  "identities.messages.4000021": "< {maximum} هجڻ گهرجي پر {actual} مليو",
  "identities.messages.4000022": "{actual} multipleOf {base} نٿو",
  "identities.messages.4000023": "وڌ ۾ وڌ {max_items} شيون جي اجازت آهي، پر {actual_items} شيون مليون",
  "identities.messages.4000024": "گهٽ ۾ گهٽ {min_items} شيون جي اجازت آهي، پر {actual_items} شيون مليون",
  "identities.messages.4000025": "انڊيڪس {index_a} ۽ {index_b} تي شيون برابر آهن",
  "identities.messages.4000026": "{allowed_types_list} جي توقع ڪئي، پر {actual_type} مليو",
  "identities.messages.4000027": "ساڳي سڃاڻپ ڪندڙ (اي ميل، فون، يوزرنيم، ...) سان اڪائونٽ اڳ ۾ ئي موجود آهي. مهرباني ڪري پنهنجي سوشل پروفائيل کي لنڪ ڪرڻ لاءِ پنهنجي موجوده اڪائونٽ ۾ سائن ان ڪريو.",
  "identities.messages.4000028": "توهان {credential_identifier_hint} سان سائن ان ڪرڻ جي ڪوشش ڪئي جيڪو اڳ ۾ ئي ٻئي اڪائونٽ جي استعمال ۾ آهي. توهان {available_credential_types_list} استعمال ڪندي سائن ان ڪري سگهو ٿا. توهان هيٺين سوشل سائن ان فراهم ڪندڙن مان هڪ استعمال ڪندي سائن ان ڪري سگهو ٿا: {available_oidc_providers_list}.",
  "identities.messages.4000029": "مستقل {expected} جي برابر هجڻ گهرجي",
  "identities.messages.4000030": "مستقل ناڪام ٿيو",
  "identities.messages.4000031": "پاس ورڊ استعمال نه ٿو ڪري سگهجي ڇاڪاڻ ته اهو سڃاڻپ ڪندڙ سان تمام گهڻو ملندڙ جلندڙ آهي.",
  "identities.messages.4000032": "پاس ورڊ گهٽ ۾ گهٽ {min_length} اکرن جو ڊگهو هجڻ گهرجي، پر {actual_length} مليو.",
  "identities.messages.4000033": "پاس ورڊ وڌ ۾ وڌ {max_length} اکرن جو ڊگهو هجڻ گهرجي، پر {actual_length} مليو.",
  "identities.messages.4000034": "پاس ورڊ ڊيٽا ڀڃڪڙين ۾ مليو آهي ۽ هاڻي استعمال نه ڪيو وڃي.",
  "identities.messages.4000035": "هي اڪائونٽ موجود نٿو يا ڪوڊ سان سائن ان سيٽ اپ نٿو ڪيو.",
  "identities.messages.4000036": "ڏنل خاصيتون هن وهڪري سان اڳ ۾ لاڳاپيل خاصيتن سان ملندڙ نٿيون.",
  "identities.messages.4000037": "هي اڪائونٽ موجود نٿو يا ڪو لاگ ان طريقو تشڪيل نٿو ڪيو ويو.",
  "identities.messages.4000038": "ڪيپچا جي تصديق ناڪام ٿي، مهرباني ڪري ٻيهر ڪوشش ڪريو.",
  "identities.messages.4010001": "مُعاملا پڄي ويو. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
  "identities.messages.4010002": "توهان کي لاگ ان ڪرڻ لاءِ ڪا حڪمت عملي نه ملي. ڇا توهان فارم صحيح طور تي ڀريو؟",
  "identities.messages.4010003": "توهان کي سائن اپ ڪرڻ لاءِ ڪا حڪمت عملي نه ملي. ڇا توهان فارم صحيح طور تي ڀريو؟",
  "identities.messages.4010004": "توهان جي سيٽنگز کي اپڊيٽ ڪرڻ لاءِ ڪا حڪمت عملي نه ملي. ڇا توهان فارم صحيح طور تي ڀريو؟",
  "identities.messages.4010005": "توهان جي اڪائونٽ کي بحال ڪرڻ لاءِ ڪا حڪمت عملي نه ملي. ڇا توهان فارم صحيح طور تي ڀريو؟",
  "identities.messages.4010006": "توهان جي اڪائونٽ جي تصديق ڪرڻ لاءِ ڪا حڪمت عملي نه ملي. ڇا توهان فارم صحيح طور تي ڀريو؟",
  "identities.messages.4010007": "درخواست اڳ ۾ ئي ڪاميابي سان مڪمل ٿي چڪي آهي ۽ ٻيهر ڪوشش نه ٿي ڪري سگهجي.",
  "identities.messages.4010008": "لاگ ان ڪوڊ غلط آهي يا اڳ ۾ ئي استعمال ٿي چڪو آهي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
  "identities.messages.4010009": "لنڪ ٿيل سندنامي ملندا نٿا.",
  "identities.messages.4010010": "توهان جو داخل ڪيل پتو موجوده اڪائونٽ ۾ ڪنهن به ڄاتل پتي سان نٿو ملي.",
  "identities.messages.4040001": "مُعاملا پڄي ويو. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
  "identities.messages.4040002": "درخواست اڳ ۾ ئي ڪاميابي سان مڪمل ٿي چڪي آهي ۽ ٻيهر ڪوشش نه ٿي ڪري سگهجي.",
  "identities.messages.4040003": "رجسٽريشن ڪوڊ غلط آهي يا اڳ ۾ ئي استعمال ٿي چڪو آهي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
  "identities.messages.4050001": "مُعاملا پڄي ويو. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
  "identities.messages.4060001": "درخواست اڳ ۾ ئي ڪاميابي سان مڪمل ٿي چڪي آهي ۽ ٻيهر ڪوشش نه ٿي ڪري سگهجي.",
  "identities.messages.4060002": "بحالي وهڪرو ناڪامي واري حالت تائين پهتو ۽ ٻيهر ڪوشش ٿيڻ گهرجي.",
  "identities.messages.4060004": "بحالي ٽوڪن غلط آهي يا اڳ ۾ ئي استعمال ٿي چڪو آهي. مهرباني ڪري وهڪري کي ٻيهر ڪوشش ڪريو.",
  "identities.messages.4060005": "مُعاملا پڄي ويو. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
  "identities.messages.4060006": "بحالي ڪوڊ غلط آهي يا اڳ ۾ ئي استعمال ٿي چڪو آهي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
  "identities.messages.4070001": "تصديقي ٽوڪن غلط آهي يا اڳ ۾ ئي استعمال ٿي چڪو آهي. مهرباني ڪري وهڪري کي ٻيهر ڪوشش ڪريو.",
  "identities.messages.4070002": "درخواست اڳ ۾ ئي ڪاميابي سان مڪمل ٿي چڪي آهي ۽ ٻيهر ڪوشش نه ٿي ڪري سگهجي.",
  "identities.messages.4070003": "تصديقي وهڪرو ناڪامي واري حالت تائين پهتو ۽ ٻيهر ڪوشش ٿيڻ گهرجي.",
  "identities.messages.4070005": "مُعاملا پڄي ويو. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
  "identities.messages.4070006": "تصديقي ڪوڊ غلط آهي يا اڳ ۾ ئي استعمال ٿي چڪو آهي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
  "identities.messages.5000001": "{reason}",
  "login.logout-button": "لاگ آئوٽ",
  "login.registration-button": "سائن اپ",
  "login.registration-label": "اڪائونٽ نٿو آهي؟",
  "login.title": "سائن ان",
  "login.subtitle": "{parts} سان سائن ان ڪريو",
  "login.title-aal2": "ٻي فڪٽر جي تصديق",
  "login.subtitle-aal2": "پنهنجي ٻي فڪٽر جي تصديق مڪمل ڪرڻ لاءِ هڪ طريقو چونڊيو",
  "login.code.subtitle": "هڪ تصديقي ڪوڊ اي ميل ذريعي موڪليو ويندو",
  "login.webauthn.subtitle": "مهرباني ڪري پنهنجي WebAuthN ڊيوائس تيار ڪريو",
  "login.totp.subtitle": "مهرباني ڪري پنهنجي Authenticator ايپ طرفان ٺاهيل ڪوڊ داخل ڪريو",
  "login.lookup_secret.subtitle": "مهرباني ڪري پنهنجي 8-عددي بيڪ اپ بحالي ڪوڊن مان هڪ داخل ڪريو",
  "login.title-refresh": "ٻيهر تصديق ڪريو",
  "login.subtitle-refresh": "{parts} سان پنهنجي سڃاڻپ جي تصديق ڪريو",
  "login.2fa.go-back": "ڪجهه ڪم نٿو ڪري؟",
  "login.2fa.go-back.link": "واپس وڃو",
  "login.2fa.method.go-back": "ٻيو طريقو چونڊيو",
  "recovery.title": "پنهنجي اڪائونٽ کي بحال ڪريو",
  "recovery.subtitle": "هڪ-وقت جي رسائي ڪوڊ حاصل ڪرڻ لاءِ پنهنجي اڪائونٽ سان لاڳاپيل سڃاڻپ ڪندڙ داخل ڪريو",
  "registration.login-button": "سائن ان",
  "registration.login-label": "اڳ ۾ ئي اڪائونٽ آهي؟",
  "registration.title": "اڪائونٽ رجسٽر ڪريو",
  "registration.subtitle": "{parts} سان سائن اپ ڪريو",
  "settings.navigation-back-button": "واپس",
  "settings.subtitle": "پنهنجي اڪائونٽ جون سيٽنگز اپڊيٽ ڪريو",
  "settings.title": "اڪائونٽ جون سيٽنگز",
  "settings.password.title": "پاس ورڊ تبديل ڪريو",
  "settings.password.description": "پنهنجو پاس ورڊ تبديل ڪريو",
  "settings.profile.title": "پروفائيل سيٽنگز",
  "settings.profile.description": "پنهنجي پروفائيل جي معلومات اپڊيٽ ڪريو",
  "settings.webauthn.title": "هارڊويئر ٽوڪن منظم ڪريو",
  "settings.webauthn.description": "پنهنجي هارڊويئر ٽوڪن جون سيٽنگز منظم ڪريو",
  "settings.messages.toast-title.success": "سيٽنگز اپڊيٽ ٿيون",
  "settings.messages.toast-title.error": "سيٽنگز اپڊيٽ نه ٿيون ڪري سگهيون",
  "verification.title": "پنهنجي اڪائونٽ جي تصديق ڪريو",
  "verification.subtitle": "ان جي تصديق ڪرڻ لاءِ پنهنجي اڪائونٽ سان لاڳاپيل اي ميل پتو داخل ڪريو",
  "two-step.password.title": "پاس ورڊ",
  "two-step.password.description": "پنهنجي اڪائونٽ سان لاڳاپيل پاس ورڊ داخل ڪريو",
  "two-step.code.title": "اي ميل ڪوڊ",
  "two-step.code.description": "هڪ تصديقي ڪوڊ توهان جي اي ميل تي موڪليو ويندو",
  "two-step.webauthn.title": "سيڪيورٽي ڪيئي",
  "two-step.webauthn.description": "تصديق ڪرڻ لاءِ پنهنجي سيڪيورٽي ڪيئي استعمال ڪريو",
  "two-step.passkey.title": "پاس ڪيئي (سفارش ڪيل)",
  "two-step.passkey.description": "فنگرپرنٽ يا چهري جي سڃاڻپ لاءِ پنهنجي ڊيوائس جو استعمال ڪريو",
  "two-step.passkey.description.error": "پنهنجي پاس ڪيئي استعمال ڪرڻ لاءِ ضروري لائبريريون لوڊ نه ٿيون ڪري سگهيون. مهرباني ڪري بعد ۾ ٻيهر ڪوشش ڪريو.",
  "two-step.totp.title": "پنهنجي Authenticator ايپ (TOTP) استعمال ڪريو",
  "two-step.totp.description": "پنهنجي authenticator ايپ مان 6-عددي هڪ-وقت ڪوڊ استعمال ڪريو",
  "two-step.lookup_secret.title": "بيڪ اپ بحالي ڪوڊ",
  "two-step.lookup_secret.description": "تصديق ڪرڻ لاءِ پنهنجي 8-عددي بيڪ اپ ڪوڊن مان هڪ استعمال ڪريو",
  "input.placeholder": "پنهنجو {placeholder} داخل ڪريو",
  "card.header.parts.oidc": "هڪ سوشل فراهم ڪندڙ",
  "card.header.parts.password.registration": "توهان جو {identifierLabel} ۽ هڪ پاس ورڊ",
  "card.header.parts.password.login": "توهان جو {identifierLabel} ۽ پاس ورڊ",
  "card.header.parts.code": "هڪ-وقت ڪوڊ",
  "card.header.parts.passkey": "هڪ پاس ڪيئي",
  "card.header.parts.webauthn": "هڪ سيڪيورٽي ڪيئي",
  "card.header.parts.totp": "توهان جي authenticator ايپ",
  "card.header.parts.lookup_secret": "هڪ بيڪ اپ بحالي ڪوڊ",
  "card.header.parts.identifier-first": "توهان جو {identifierLabel}",
  "misc.or": "يا",
  "forms.label.forgot-password": "پاس ورڊ وساري ويا؟",
  "forms.label.recover-account": "اڪائونٽ بحال ڪريو",
  "settings.totp.title": "Authenticator ايپ",
  "settings.totp.description": "پنهنجي اڪائونٽ جي سيڪيورٽي کي بهتر بڻائڻ لاءِ پنهنجي اڪائونٽ ۾ TOTP Authenticator ايپ شامل ڪريو. مشهور Authenticator ايپس آهن LastPass ۽ Google Authenticator",
  "settings.totp.info.not-linked": "فعال ڪرڻ لاءِ پنهنجي authenticator سان QR ڪوڊ اسڪين ڪريو ۽ ڪوڊ داخل ڪريو.",
  "settings.totp.info.linked": "توهان وٽ في الحال هڪ authenticator ايپ ڳنڍيل آهي.",
  "settings.lookup_secret.title": "بيڪ اپ بحالي ڪوڊ (ٻي فڪٽر)",
  "settings.lookup_secret.description": "بحالي ڪوڊ 2FA لاءِ هڪ محفوظ بيڪ اپ آهن، جيڪي توهان کي پنهنجي 2FA ڊيوائس وڃائڻ جي صورت ۾ پنهنجي اڪائونٽ تائين رسائي ٻيهر حاصل ڪرڻ جي اجازت ڏين ٿا.",
  "settings.oidc.title": "ڳنڍيل اڪائونٽ",
  "settings.oidc.description": "پنهنجي اڪائونٽ سان سوشل لاگ ان فراهم ڪندڙ ڳنڍيو.",
  "settings.oidc.info": "انهن فراهم ڪندڙن کان ڳنڍيل اڪائونٽ توهان جي اڪائونٽ ۾ لاگ ان ڪرڻ لاءِ استعمال ٿي سگهن ٿا",
  "settings.webauthn.info": "هارڊويئر ٽوڪن ٻي-فڪٽر جي تصديق لاءِ استعمال ٿين ٿا يا پاس ڪيئي سان پهرين-فڪٽر طور",
  "settings.passkey.title": "پاس ڪيئي منظم ڪريو",
  "settings.passkey.description": "پنهنجي پاس ڪيئي جون سيٽنگز منظم ڪريو",
  "settings.passkey.info": "پنهنجي پاس ڪيئي جون سيٽنگز منظم ڪريو",
  "card.footer.select-another-method": "ٻيو طريقو چونڊيو",
  "account-linking.title": "اڪائونٽ لنڪ ڪريو",
  "property.password": "پاس ورڊ",
  "property.email": "اي ميل",
  "property.phone": "فون",
  "property.username": "يوزرنيم",
  "property.identifier": "سڃاڻپ ڪندڙ",
  "property.code": "ڪوڊ",
  "property.recovery_address": "بحالي پتو",
  "consent.title": "{party} کي اختيار ڏيو",
  "consent.subtitle": "هڪ ٽئين پارٽي ايپليڪيشن توهان جي اڪائونٽ {identifier} سان لاڳاپيل معلومات تائين رسائي چاهي ٿي.",
  "consent.scope.openid.title": "سڃاڻپ",
  "consent.scope.openid.description": "ايپليڪيشن کي توهان جي سڃاڻپ جي تصديق ڪرڻ جي اجازت ڏئي ٿي. اها تصديق ۽ هڪ معتبر لاگ ان تجربو لاءِ ضروري آهي.",
  "consent.scope.offline_access.title": "آف لائن رسائي",
  "consent.scope.offline_access.description": "هن ايپليڪيشن کي توهان کو سائن ان ۾ رکڻ جي اجازت ڏئي ٿي جيتوڻيڪ توهان ان کي فعال طور استعمال نٿا ڪري رهيا آهيو.",
  "consent.scope.profile.title": "پروفائيل معلومات",
  "consent.scope.profile.description": "توهان جي بنيادي پروفائيل تفصيلن تائين رسائي جي اجازت ڏئي ٿي، بشمول توهان جو يوزرنيم، پهريون نالو، ۽ آخري نالو.",
  "consent.scope.email.title": "اي ميل پتو",
  "consent.scope.email.description": "توهان جو اي ميل پتو ۽ ان جي تصديق جي حالت حاصل ڪريو.",
  "consent.scope.address.title": "جسماني پتو",
  "consent.scope.address.description": "توهان جي پوسٽل پتي تائين رسائي.",
  "consent.scope.phone.title": "فون نمبر",
  "consent.scope.phone.description": "توهان جو فون نمبر ۽ ان جي تصديق جي حالت حاصل ڪريو.",
  "error.title.what-happened": "ڇا ٿيو؟",
  "error.title.what-can-i-do": "مان ڇا ڪري سگهان ٿو؟",
  "error.instructions": "مهرباني ڪري ڪجهه منٽن ۾ ٻيهر ڪوشش ڪريو يا ويب سائيٽ آپريٽر سان رابطو ڪريو.",
  "error.footer.text": "هن نقص جي رپورٽ ڪرڻ دوران، مهرباني ڪري هيٺيون معلومات شامل ڪريو:",
  "error.footer.copy": "ڪاپي ڪريو",
  "error.action.go-back": "واپس وڃو",
  "identities.messages.4000039": "نئون پاسورڊ پراڻي پاسورڊ کان مختلف هجڻ گهرجي.",
  "identities.messages.4000040": "هڪ صحيح اي ميل پتو داخل ڪريو",
  "identities.messages.4000041": "هڪ صحيح فون نمبر داخل ڪريو",
  "captcha.error": "سيڪيورٽي جي تصديق ناڪام ٿي وئي. مھرباني ڪري ڪجھ دير کان پوءِ ٻيھر ڪوشش ڪريو. جيڪڏهن مسئلو جاري رهي، مدد سان رابطو ڪريو.",
  "identities.messages.5000002": "ڪو به تصديق ڪرڻ جو طريقو موجود ناهي. مهرباني ڪري سسٽم اڊمنسٽريٽر سان رابطو ڪريو.",
  "identities.messages.4010011": "هي اڪائونٽ معطّل ڪيو ويو آهي. مهرباني ڪري مدد لاءِ سپورٽ سان رابطو ڪريو.",
  "identities.messages.1070018": "اي ميل يا فون نمبر",
  "identities.messages.1080004": "توهان جي فراهم ڪيل فون نمبر تي تصديقي ڪوڊ واري هڪ متن ميساج موڪليو ويو آهي. جيڪڏهن توهان کي متن ميساج ملي نه آهي، ته نمبر جي اسپيلنگ چيڪ ڪريو ۽ اهو ضرور يقيني بڻايو ته توهان انهي نمبر کي استعمال ڪريو جنهن سان توهان رجسٽر ڪيو آهي.",
  "identities.messages.1080005": "تو پنهنجي فون نمبر جي تصديق ڪئي.",
  "identities.messages.5000003": "توا جي تنظيم کي ايس ايس او (SSO) تصديق جي ضرورت آهي، پر ڪو به ايس ايس او (SSO) فراهم ڪندڙ ترتيب نه ڏنو ويو آهي. مهرباني ڪري نظام جي منتظم سان رابطو ڪريو.",
  "identities.messages.1010024": "هڪ هارڊويئر ڪي سان ساين ان ڪريو",
  "identities.messages.1010025": "هڪ ڪوڊ توهان جي پتي تي موڪليو ويو آهي. جيڪڏهن توهان کي اهو نه مليو، مهرباني ڪري ٻيهر ڪوشش ڪريو.",
  "identities.messages.4000042": "توهان وٽ ڪو به DeviceAuthn ڊوائيس ترتيب نه آهي.",
  "identities.messages.4000043": "دي ويل ويب آٿين لاگ ان صحيح ناهي، مهرباني ڪري ٻيهر ڪوشش ڪريو.",
  "identities.messages.4000044": "دي ويل آيل DeviceAuthn دستخط صحيح ناهي.",
  "identities.messages.4050002": "تو صرف هڪ دفعي ۾ هڪ ئي پتو تبديل ڪري سگهين ٿو. مھرباني ڪري هر پتو الڳ الڳ اپڊيٽ ڪريو."
}
